<template>
  <v-row class="ma-0" :style="contentsHeight">
    <v-col cols="12">
      <v-row>
        <v-col cols="3">
          Dummy users creation
        </v-col>
        <v-col cols="4">
          <v-select
            ref="df"
            :items='mySchools'
            label="School"
            v-model='school'
            item-text="name"
            item-value="key"
            hideDetails
            outlined
            dense
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field
            label="Number"
            hideDetails
            dense
            outlined
            v-model='num'
            ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-row>
          <v-btn color="primary" elevation="0" class="mx-2" @click="createDialog = true">Create</v-btn>
          <v-btn color="error" elevation="0" class="mx-2" @click="removeDialog = true">Remove</v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          Dummy students creation
        </v-col>
        <v-col cols="2">
          <v-select
            ref="df"
            :items='mySchools'
            label="School"
            v-model='school'
            item-text="name"
            item-value="key"
            hideDetails
            outlined
            dense
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
            ref="df"
            :items='myGroups'
            label="Group"
            v-model='group'
            item-text="name"
            item-value="key"
            hideDetails
            outlined
            dense
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="1">
          <v-text-field
            label="Number"
            hideDetails
            dense
            outlined
            v-model='num'
            ></v-text-field>
        </v-col>
        <v-col cols="1" class="px-0">
          <v-select
            ref="df"
            :items='status'
            label="Status"
            v-model='sts'
            item-text="name"
            item-value="key"
            hideDetails
            outlined
            dense
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-row>
          <v-btn color="primary" elevation="0" class="mx-2" @click="createDialog2 = true">Create</v-btn>
          <v-btn color="error" elevation="0" class="mx-2" @click="removeDialog2 = true">Remove</v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <!-- <v-row>
        <v-col cols="4">
          <v-btn class="text-capitalize" @click="getSchools()">Get firestore</v-btn>
        </v-col>
        <v-col cols="4">
          <v-text-field
            ref="path"
            label="Path"
            hideDetails
            dense
            outlined
            v-model='path'
            :rules="[rules.required]"
            ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select
            ref="project"
            :items='projects'
            label="Project"
            v-model='project'
            item-text="name"
            item-value="id"
            hideDetails
            outlined
            dense
            :rules="[rules.required]"
          ></v-select>
        </v-col>
      </v-row> -->

      <v-row>
        <v-col cols="4">
          <!-- <v-btn class="text-capitalize" color="deep-purple" dark @click="diagnose = true">Diagnose</v-btn> -->
        </v-col>
        <v-col cols="4">
        </v-col>
        <v-col cols="4">
        </v-col>
      </v-row>

    </v-col>
    <!-- <v-col cols="12" class="pa-0">
      <v-card flat color="transparent" :style="contentsHeight">
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center" justify="center">
            <v-col cols="4"></v-col>
           <v-col cols="4">
              <span class="error--text">検索結果はコンソールに表示されます</span>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="チャット全文検索"
                clearable
                color="primary"
                class="px-4 ma-0"
                @click:clear="onClear()"
                @keyup.enter.native="onSearch()">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="reCreateMetrics">生徒情報から指標を再生成（⚠️要注意）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc1"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="reCreateActs">生徒の有無から実績値を再生成（⚠️要注意）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc2"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="reCreateActsFromStatus">生徒のステータスから実績値を再生成（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc4"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="removePlans">不要な計画データ削除（⚠️要注意）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc2"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="removeFees">不要な費用データ削除（⚠️要注意）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc2"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="reCheckDateFormat">生徒の日付フォーマット修正（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="df"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="createYCS">YCSテストデータ作成（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="yt"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="error" @click="deleteUsersSchools">ユーザ塾情報を削除（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="yt"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" disabled @click="createActsData">開発用: 生徒数実績生成（⚠️要注意）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
              <v-select
                :items="$YEARS"
                label="年度"
                hideDetails
                v-model.number="year"
                class="pr-1"
                item-text="name"
                item-value="value"
                outlined
                dense
                disabled
              ></v-select>
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc3"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
                disabled
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="removeDialog = true">サーバ移行：全ての画像URLを消去（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="removeStudentDialog = true">サーバ移行：無効な生徒データ消去（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="school ? removeSchoolDialog = true : ''">サーバ移行: 塾（塾に属する教室・ユーザ他）消去（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
              <v-select
                ref="sc3"
                class="pr-1"
                :items='schools'
                label='塾'
                v-model='school'
                item-text="name"
                item-value="key"
                hideDetails
                outlined
                dense
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="removeNoneAciveSchoolDialog = true">サーバ移行：不要な塾情報を削除（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="removeAllDialog = true">サーバ移行：完全削除（⚠️）</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="taskCheckDialog = true">無効なタスクを削除</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center">
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="4">
              <v-btn color="primary" @click="reCheckStudent">生徒のステータスチェック</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2" class="pa-0" align="center"></v-col>
            <v-col cols="4" class="pa-0" align="end">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col> -->

    <!-- <div>
      <app-basic-dialog
        v-if='privError'
        @dismissed="onDismissed"
        :title="'権限'"
        :message="'特権モードで操作をしてください'"
        :dialog='privError'
        :color="'error'"
        :cancel='false'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeDialog'
        @dismissed="onDismissed"
        :title="'データ消去'"
        :message="'全ての画像URLを消去します'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeStudentDialog'
        @dismissed="onDismissed"
        :title="'データ消去'"
        :message="'無効な生徒データを消去します'"
        :dialog='removeStudentDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeSchoolDialog'
        @dismissed="onDismissed"
        :title="'塾消去'"
        :message="getSchoolName() + ' 関連データを消去します'"
        :dialog='removeSchoolDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeNoneAciveSchoolDialog'
        @dismissed="onDismissed"
        :title="'塾情報消去'"
        :message="'不要な塾関連データを消去します'"
        :dialog='removeNoneAciveSchoolDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='removeAllDialog'
        @dismissed="onDismissed"
        :title="'塾情報消去'"
        :message="'データを完全消去します'"
        :dialog='removeAllDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='taskCheckDialog'
        @dismissed="onDismissed"
        :title="'タスク削除'"
        :message="'無効なタスクを削除します'"
        :dialog='taskCheckDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div> -->

    <div class="text-center">
      <v-dialog
        v-model="diagnose"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <diagnose :title="'Diagnose'" @dismissed="onDismissed"></diagnose>
      </v-dialog>
    </div>

    <div v-if="createDialog">
      <app-basic-dialog
        v-if='createDialog'
        @dismissed="onDismissed"
        dense
        :title="'ユーザ生成'"
        :message="'ユーザを自動生成します'"
        :dialog='createDialog'
        :color="'primary'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div v-if="removeDialog">
      <app-basic-dialog
        v-if='removeDialog'
        @dismissed="onDismissed"
        dense
        :title="'ユーザ削除'"
        :message="'ユーザを自動削除します'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div v-if="createDialog2">
      <app-basic-dialog
        v-if='createDialog2'
        @dismissed="onDismissed"
        dense
        :title="'生徒生成'"
        :message="'生徒を自動生成します'"
        :dialog='createDialog2'
        :color="'primary'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div v-if="removeDialog2">
      <app-basic-dialog
        v-if='removeDialog2'
        @dismissed="onDismissed"
        dense
        :title="'生徒削除'"
        :message="'生徒を自動削除します'"
        :dialog='removeDialog2'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>
  </v-row>
</template>

<script>
import * as async from 'async'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment-timezone'
import Diagnose from './TemplateDiagnose.vue'

// const moment = extendMoment(Moment)
export default {
  components: {
    Diagnose: Diagnose
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      students: 'students/students',
      maintenance: 'shared/maintenance',
      windowSize: 'shared/windowSize'
    }),
    mySchools () {
      var temp = []
      for (var i in this.schools) {
        if (this.schools[i].enable) {
          temp.push(JSON.parse(JSON.stringify(this.schools[i])))
        }
      }
      return temp
    },
    myGroups () {
      var temp = []
      var index = this.schools.findIndex(school => school.key === this.school)
      if (index !== -1) {
        var keys = Object.keys(this.schools[index].groups)
        for (var i in keys) {
          index = this.groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            if (this.groups[index].enable && this.groups[index].classroom) {
              temp.push(JSON.parse(JSON.stringify(this.groups[index])))
            }
          }
        }
      }
      return temp
    },
    myDbgUsers () {
      var temp = []
      for (var i in this.users) {
        if (this.users[i].debug) {
          temp.push(JSON.parse(JSON.stringify(this.users[i])))
        }
      }
      return temp
    },
    myDbgStudents () {
      var temp = []
      for (var i in this.students) {
        if (this.students[i].debug) {
          temp.push(JSON.parse(JSON.stringify(this.students[i])))
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      createDialog: false,
      removeDialog: false,
      createDialog2: false,
      removeDialog2: false,
      diagnose: false,
      loading: false,
      school: null,
      num: 1,
      sts: 6,
      group: null,
      status: [
        { name: '在', key: 6 },
        { name: '退', key: 7 }
      ],
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  created () {
  },
  methods: {
    createUsers () {
      var vm = this
      this.loading = true
      var accouns = [...Array(Number(this.num))].map((_, i) => 'dbg-' + String(i + 1))
      async.eachSeries(accouns, function (n, cb) {
        vm.createAccount(n).then(function (response) {
          if (response.data.uid) {
            vm.addUser(response.data).then(function () {
              const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
              pause(50).then(() => {
                cb()
              })
            })
          } else {
            cb()
          }
        })
      }, function (error) {
        if (error) {
        }
        vm.loading = false
      })
    },
    addUser (user) {
      return new Promise((resolve) => {
        var payload = JSON.parse(JSON.stringify(this.$store.getters['users/initial']))
        payload.name = user.email
        payload.key = user.uid
        payload.email = user.email
        payload.schools[this.school] = true
        payload.primary = this.school
        payload.public = true
        payload.registered = true
        payload.avatar = {
          path: 'https://lh3.googleusercontent.com/-94gVXp6WGFY/AAAAAAAAAAI/AAAAAAAAACs/9SRHs2jsH6c/photo.jpg',
          thumbnail: 'https://lh3.googleusercontent.com/-94gVXp6WGFY/AAAAAAAAAAI/AAAAAAAAACs/9SRHs2jsH6c/photo.jpg'
        }
        payload['debug'] = true
        this.$store.dispatch('users/create', payload).then(() => {
          resolve()
        })
      })
    },
    createAccount (email) {
      return new Promise((resolve) => {
        var payload = {
          email: email + '@ubunifu.co',
          emailVerified: true,
          password: 'password',
          displayName: email
        }
        const url = this.$FUNCTIONS_URL + '/user/add'
        firebase.auth().currentUser.getIdToken().then(function (token) {
          axios.post(url, payload, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(function (response) {
            resolve(response)
          }).catch(function (error) {
            if (error) {
              // console.log(error)
            }
            resolve()
          })
        })
      })
    },
    removeUsers () {
      var vm = this
      this.loading = true
      async.eachSeries(this.myDbgUsers, function (n, cb) {
        vm.deleteRefs(n.key).then(function () {
          vm.deleteSchool(n).then(function () {
            vm.deleteUser(n.key).then(function () {
              vm.removeAccount(n.key).then(function () {
                const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
                pause(50).then(() => {
                  cb()
                })
              })
            })
          })
        })
      }, function (error) {
        if (error) {
        }
        vm.loading = false
      })
    },
    deleteRefs (uid) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('chats_refs').doc(uid).delete().then(function () {
          resolve()
        }).catch(function (error) {
          if (error) {
          }
          resolve()
        })
      })
    },
    deleteSchool (user) {
      return new Promise((resolve) => {
        var keys = Object.keys(user.schools)
        var index = this.mySchools.findIndex(school => school.key === keys[0])
        if (index !== -1) {
          var s = this.mySchools[index]
          delete s.users[user.key]
          this.$store.dispatch('schools/write', JSON.parse(JSON.stringify(s))).then(function () {
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    deleteUser (uid) {
      return new Promise((resolve) => {
        this.$store.dispatch('users/delete', uid).then(function () {
          resolve()
        })
      })
    },
    removeAccount (uid) {
      return new Promise((resolve) => {
        var payload = {
          uid: uid
        }
        const url = this.$FUNCTIONS_URL + '/user/remove'
        firebase.auth().currentUser.getIdToken().then(function (token) {
          axios.post(url, payload, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(function (response) {
            resolve()
          }).catch(function (error) {
            if (error) {
              // console.log(error)
            }
            resolve()
          })
        })
      })
    },
    createStudents () {
      var vm = this
      this.loading = true
      var accouns = [...Array(Number(this.num))].map((_, i) => 'dbg-' + String(i + 1))
      async.eachSeries(accouns, function (n, cb) {
        vm.addStudent(n).then(function (response) {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(50).then(() => {
            cb()
          })
        })
      }, function (error) {
        if (error) {
        }
        vm.loading = false
      })
    },
    addStudent (n) {
      var vm = this
      return new Promise((resolve) => {
        var name = n.split('-')
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/initial']))
        payload.sei = name[0]
        payload.mei = name[1]
        payload.seiY = name[0]
        payload.meiY = name[1]
        payload.admission = moment(new Date()).format('YYYY-MM-DD')
        payload.charge = firebase.auth().currentUser.uid
        payload.grade = Number(name[1]) % 13
        payload.groups[this.group] = true
        payload.schools[this.school] = true
        payload.status = this.sts
        payload.updatedAt = parseInt(new Date().getTime())
        payload.createdAt = parseInt(new Date().getTime())
        payload['debug'] = true
        vm.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          resolve()
        })
      })
    },
    removeStudents () {
      var vm = this
      this.loading = true
      async.eachSeries(this.myDbgStudents, function (n, cb) {
        vm.deleteStudent(n.key).then(function () {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(50).then(() => {
            cb()
          })
        })
      }, function (error) {
        if (error) {
        }
        vm.loading = false
      })
    },
    deleteStudent (uid) {
      return new Promise((resolve) => {
        this.$store.dispatch('students/delete', uid).then(function () {
          resolve()
        })
      })
    },
    // initSchoolPriv () {
    //   var vm = this
    //   const db = firebase.firestore()
    //   var dbRef = db.collection('/schools')
    //   this.loading = true
    //   dbRef.get().then(function (snapshots) {
    //     async.eachSeries(snapshots.docs, function (doc, cb) {
    //       var data = JSON.parse(JSON.stringify(doc.data()))
    //       var ref = db.collection('/schools').doc(data.key)
    //       ref.update({
    //         privileges: {
    //           plan: true,
    //           edit: true }
    //       }).then(function () {
    //         cb()
    //       })
    //     }, function (error) {
    //       if (error) {
    //       }
    //       vm.loading = false
    //     })
    //   })
    // },
    // reCheckData () {
    //   var vm = this
    //   this.checkFees().then(function () {
    //     vm.checkStudents().then(function () {
    //       vm.checkTemplates().then(function () {
    //       })
    //     })
    //   })
    // },
    // checkFees () {
    //   var vm = this
    //   this.loading = true
    //   return new Promise((resolve) => {
    //     var fees = []
    //     const db = firebase.firestore()
    //     var dbRef = db.collection('/metrics_fees')
    //     dbRef.get().then(function (snapshots) {
    //       async.eachSeries(snapshots.docs, function (doc, cb) {
    //         var data = doc.data()
    //         fees.push(JSON.parse(JSON.stringify(data)))
    //         cb()
    //       }, function (error) {
    //         if (error) {
    //         }
    //         async.eachSeries(fees, function (item, cb2) {
    //           for (var i = 0; i < 12; i++) {
    //             if (typeof item[i] !== 'undefined') {
    //               var keys = Object.keys(item[i])
    //               for (var x in keys) {
    //                 if (item[i][keys[x]].value === null) {
    //                   // eslint-disable-next-line no-console
    //                   console.log(item.key, item.year, i, keys[x], item[i][keys[x]])
    //                 }
    //               }
    //             }
    //           }
    //           cb2()
    //         }, function (error) {
    //           if (error) {
    //           }
    //           vm.loading = false
    //           resolve()
    //         })
    //       })
    //     })
    //   })
    // },
    // updateStudents (item) {
    //   return new Promise((resolve) => {
    //     const db = firebase.firestore()
    //     var ref = db.collection('/students').doc(item.key)
    //     ref.update({ contacts: JSON.parse(JSON.stringify(item.contacts)) }).then(function () {
    //       resolve()
    //     })
    //   })
    // },
    // checkStudents () {
    //   var vm = this
    //   this.loading = true
    //   return new Promise((resolve) => {
    //     var students = []
    //     const db = firebase.firestore()
    //     var dbRef = db.collection('/students')
    //     dbRef.get().then(function (snapshots) {
    //       async.eachSeries(snapshots.docs, function (doc, cb) {
    //         var data = doc.data()
    //         students.push(JSON.parse(JSON.stringify(data)))
    //         cb()
    //       }, function (error) {
    //         if (error) {
    //         }
    //         async.eachSeries(students, function (item, cb2) {
    //           var update = false
    //           for (var i in item.contacts) {
    //             if (typeof item.contacts[i].available1 === 'undefined' || typeof item.contacts[i].available2 === 'undefined') {
    //               item.contacts[i]['available1'] = { from: null, to: null, flag: true }
    //               item.contacts[i]['available2'] = { from: null, to: null, flag: true }
    //               update = true
    //             }
    //           }
    //           if (update) {
    //             vm.updateStudents(item).then(function () {
    //               // eslint-disable-next-line no-console
    //               console.log('update: ', item.key)
    //               cb2()
    //             })
    //           } else {
    //             cb2()
    //           }
    //         }, function (error) {
    //           if (error) {
    //           }
    //           vm.loading = false
    //           resolve()
    //         })
    //       })
    //     })
    //   })
    // },
    // updateTemplates (item) {
    //   return new Promise((resolve) => {
    //     const db = firebase.firestore()
    //     var ref = db.collection('/template_events').doc(item.key)
    //     ref.update({ period: 1 }).then(function () {
    //       resolve()
    //     })
    //   })
    // },
    // checkTemplates () {
    //   var vm = this
    //   this.loading = true
    //   return new Promise((resolve) => {
    //     var templates = []
    //     const db = firebase.firestore()
    //     var dbRef = db.collection('/template_events')
    //     dbRef.get().then(function (snapshots) {
    //       async.eachSeries(snapshots.docs, function (doc, cb) {
    //         var data = doc.data()
    //         templates.push(JSON.parse(JSON.stringify(data)))
    //         cb()
    //       }, function (error) {
    //         if (error) {
    //         }
    //         async.eachSeries(templates, function (item, cb2) {
    //           if (item.period === null) {
    //             vm.updateTemplates(item).then(function () {
    //               // eslint-disable-next-line no-console
    //               console.log('update: ', item.key)
    //               cb2()
    //             })
    //           } else {
    //             cb2()
    //           }
    //         }, function (error) {
    //           if (error) {
    //           }
    //           vm.loading = false
    //           resolve()
    //         })
    //       })
    //     })
    //   })
    // },
    onDismissed: function (value) {
      if (this.diagnose) {
        this.diagnose = false
        return
      }
      if (this.createDialog2) {
        this.createDialog2 = false
        if (value) {
          this.createStudents()
        }
        return
      }
      if (this.removeDialog2) {
        this.removeDialog2 = false
        if (value) {
          this.removeStudents()
        }
        return
      }
      if (this.createDialog) {
        this.createDialog = false
        if (value) {
          this.createUsers()
        }
        return
      }
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.removeUsers()
        }
      }
    }
  }
}
</script>

<style>
</style>
